import { render, staticRenderFns } from "./company-introduction.vue?vue&type=template&id=f019980e&scoped=true"
import script from "./company-introduction.vue?vue&type=script&lang=js"
export * from "./company-introduction.vue?vue&type=script&lang=js"
import style0 from "./company-introduction.vue?vue&type=style&index=0&id=f019980e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f019980e",
  null
  
)

export default component.exports